import { useMutation } from '@tanstack/react-query';
import { resendLoginMfa } from '../api/resednLoginApi';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { ResendLoginMfaPayload } from '../api/resednLoginApi';

type UseSendResendLoginParams = Omit<
  UseMutationOptions<unknown, unknown, ResendLoginMfaPayload>,
  'mutationFn' | 'mutationKey'
>;

export const useSendResendLogin = ({
  onSuccess,
  onError,
  onSettled,
}: UseSendResendLoginParams = {}) => {
  const {
    mutateAsync: asyncResendLoginMfa,
    isPending: isLoadingResendLoginMfa,
    data: resendLoginMfaResponse,
  } = useMutation({
    mutationFn: resendLoginMfa,
    mutationKey: ['resendLoginMfa'],
    onSuccess,
    onError,
    onSettled,
  });

  return {
    asyncResendLoginMfa,
    isLoadingResendLoginMfa,
    resendLoginMfaResponse,
  };
};
